import { Flex } from "@base-ui";
import { CmsPage } from "./CmsPage";
import { AdminNavigation } from "./AdminNavigation";
import { jsx as _jsx } from "react/jsx-runtime";
export var AdminView = function AdminView(_ref) {
  var children = _ref.children;
  var controlpanel = /*#__PURE__*/_jsx(AdminNavigation, {});
  var view = /*#__PURE__*/_jsx(Flex.Column, {
    children: children
  });
  return /*#__PURE__*/_jsx(CmsPage, {
    id: "admin-navigation",
    title: "Administration",
    controlpanel: controlpanel,
    view: view
  });
};